import ViewTime from './viewTime';

import './viewTime.css';

export default ViewTime;
